(function(){
  // 1. Header scroll
  var h=document.querySelector('header-component, .header, #header-component');
  if(h){
    window.addEventListener('scroll',function(){
      h.classList.toggle('header--scrolled',window.scrollY>60);
    },{passive:true});
  }
  // 2. Cursor
  if(window.innerWidth>900&&!('ontouchstart' in window)){
    var c=document.getElementById('slrCursor'),r=document.getElementById('slrCursorRing');
    if(c&&r){
      var mx=0,my=0,rx=0,ry=0;
      document.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;});
      (function a(){rx+=(mx-rx)*.18;ry+=(my-ry)*.18;c.style.left=mx+'px';c.style.top=my+'px';r.style.left=rx+'px';r.style.top=ry+'px';requestAnimationFrame(a);})();
      document.querySelectorAll('a,button').forEach(function(el){
        el.addEventListener('mouseenter',function(){c.style.width='20px';c.style.height='20px';r.style.width='52px';r.style.height='52px';});
        el.addEventListener('mouseleave',function(){c.style.width='12px';c.style.height='12px';r.style.width='36px';r.style.height='36px';});
      });
    }
  }
  // 3. Reveal scroll
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting)e.target.classList.add('slr-visible');});},{threshold:.1});
    document.querySelectorAll('.slr-reveal').forEach(function(el){obs.observe(el);});
  }
  // 4. Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var t=document.querySelector(this.getAttribute('href'));
      if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}
    });
  });
})();